import React, { useEffect, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import axiosInstance from '../axiosInstance';
import MyChatComponent from './MyChatComponent'; // Import MyChatComponent
import MyUserContext from '../myUserContext'; // Import MyUserContext
import { Drawer } from "@mantine/core";

const ArtEventDropdown = ({ eventId, onClose, language, eventType="artEvent", initialArtEvent = null }) => {
  const myUser = useContext(MyUserContext);
  const navigate = useNavigate(); // Initialize useNavigate
  const [artEvent, setArtEvent] = useState(initialArtEvent);

  const updateArtEvent = () => {
    if (initialArtEvent) {
      return; // Skip fetching if initialArtEvent is provided
    }

    if (eventType === 'recommendation') { // it will live, or not
      axiosInstance
      .get(`/recommendations/${eventId}`)
      .then((response) => {
        setArtEvent({
          event: response.data.recommendation,
          art: response.data.art,
          fromUser: response.data.fromUser,
          toUser: response.data.toUser,
          chat: response.data.chat,
        });
      })
      .catch((error) => {
        console.error(error);
      });
      return;
    }

    if (eventType === 'artEvent') {
      axiosInstance
      .get(`/artEvents/${eventId}`)
      .then((response) => {
        setArtEvent({
          event: response.data.event,
          art: response.data.art,
          chat: response.data.chat,
          eventOwnerUserName: response.data.eventOwnerUserName,
          eventOwnerUserAvatarUrl: response.data.eventOwnerUserAvatarUrl
        });
      })
      .catch((error) => {
        console.error(error);
      });
      return;
    }
  };

  useEffect(() => {
    updateArtEvent();
  }, []);

  if (!artEvent) {
    return <div></div>;
  }
  
  let actualEventType = eventType;
  if (eventType === "artEvent") {
    if (artEvent.event.type === 1) {
      actualEventType = "finished";
    } else if (artEvent.event.type === 2) {
      actualEventType = "todo";
    } else if (artEvent.event.type === 3) {
      actualEventType = "like";
    }
  } // else it's recommendation

  return (
    <Drawer opened onClose={onClose} position="bottom" size="75vh" radius="md" padding="md">
      <div
        className="flex justify-center items-center py-2 mt-2 mb-2 space-x-1 font-bold"
      >
        <span>{language === "ru" ? "Чат в моей библиотеке" : "Chat in my library"}</span>
        <span
          onClick={() => navigate(`/artEvents/${eventId}`)}
          className="cursor-pointer hover:underline"
        >
          {language === "ru" ? " (развернуть)" : " (expand)"}
        </span>
      </div>

      <MyChatComponent key={artEvent.event.chatId} chatId={artEvent.event.chatId} _userChatInfo={artEvent.chat} language={language} myUserInfo={myUser ? myUser.myUserInfo : null} chatOwnerInfo={{type:eventType, id: artEvent.event.id}} isDropdown={true}/>
    </Drawer>
  );
};

export default ArtEventDropdown;
